//reducer pt auth
// (state, action) => newState
import { authConstants } from "../constants/auth";
import { user_types } from "../constants/auth";

//pentru teste: user_type poate sa fie : guest, echipa, admin
// *********pt guest: ***********
const initialState = () => ({
    user_id: null,
    user_name: '',
    user_type: user_types.GUEST
});

const authReducer = (state = initialState(), action) => {
    switch (action.type) {
        case authConstants.LOGIN_SUCCES: {
            return {
                ...state, // copiaza keyle din state in obiectul returnat
                user_id: action.user_id,
                user_name: action.user_name,
                user_type: action.user_type
            }
        }

        case authConstants.LOGOUT_SUCCES: {
            return initialState();
            // la log out returnal copie a stateului initial
        }

        default: {
            return state;
        }
    }
}

export default authReducer;

// navbar il fac in functie de user_type
// navbar pt fiecare in parte